<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div>
    <span class="font-semibold text-primary">
    Journal Vouchers ({{ data?.formModel?.voucherType ? data?.formModel?.voucherType : data?.formModel?.voucherTypeName }} No: {{ data?.formModel?.invoiceModel?.invoiceNo ? data?.formModel?.invoiceModel?.invoiceNo : data?.formModel?.invoiceNo }})
    </span>
    </div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button" (click)="activeModal.dismiss()"></app-svg-icon>
</div>
<form autocomplete="off" class="theme-form" ngNativeValidate>
    <div class="modal-body px-1 pb-0">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div>
                <span class="text-pink">Date: {{invoiceDate??'NA'}}</span>
            </div>
            <app-export-dropdown [requestModel]="apiRequestModel" [gridApi]="[gridApi]" [gridName]="['JOURNAL_VOUCHER_GRID']" (callApiForExport)="callApiForExport($event)"></app-export-dropdown>
        </div>
        <hr class="my-2">
        <div class="row mx-0 gap-2 flex-fill mb-3">
            <div class="col p-0">
                <div class="h-500px position-relative">
                    <app-ag-grid
                    class="all_aggrid_tables" 
                    [dataModel]="agGridJournalVouchers"
                    (gridReady)="onGridReady($event)"
                    [columnSettings]="true"
                   ></app-ag-grid>     
                </div>
            </div>
        </div>
    </div>
</form>
